<script lang="ts">
	import Spinner from './Spinner.svelte';

	interface Props {
		disabled?: boolean;
		submitting?: boolean;
		delayed?: boolean;
		class?: string;
		children?: import('svelte').Snippet;
	}

	let {
		disabled = false,
		submitting = false,
		delayed = false,
		class: clazz = '',
		children
	}: Props = $props();
</script>

<button type="submit" class="btn btn-primary {clazz}" disabled={disabled || submitting}>
	{#if submitting || delayed}
		<span class="mr-2">
			<Spinner />
		</span>
	{/if}
	{@render children?.()}</button
>
